<template>
  <div class="footer-actions">
    <slot>
      <bp-button
        color="neutral"
        label="Cancelar"
        variant="filled-1"
        class="order-1 order-lg-0"
        @click="$emit('cancel')"
      />
      <bp-button
        class="order-0 order-lg-1"
        :label="label"
        :loading="loading"
        :disabled="disabled"
        @click="$emit('submit')"
      />
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: String,
      default: "Salvar"
    }
  },
  watch: {
    loading() {},
    disabled() {}
  }
};
</script>

<style lang="scss" scoped>
.footer-actions {
  gap: 16px;
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    justify-content: unset;
  }
}
</style>
